module.exports = __webpack_public_path__ + "static/media/QUDO_LogoAlpha.ced6a388.svg";